import {CustomerSubscription} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardProperty,
} from '@flexinet/ui-components';
import {useAllowedItems} from '../../../hooks/useAllowedProperties.ts';
import {CreatedByProfileFormatter, UserProfile} from '../../../components/CreatedByProfileFormatter.tsx';

export const MetadataPropertyCard = ({record}: { record: CustomerSubscription }) => {

    const metadata = [
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Created By',
            value: <CreatedByProfileFormatter record={record as unknown as UserProfile}/>,
            rbac: 'UpdateSubscription',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }, {
            label: 'Updated By',
            value: record.updatedByUsername ?? 'n/a',
            rbac: 'UpdateSubscription',
            span: 12,
        }] as PlatformPropertyCardProperty[];

    const {filterAllowed} = useAllowedItems();
    const metadataAllowedProperties = filterAllowed(metadata) as PlatformPropertyCardProperty[];

    return (<PlatformPropertyCard properties={metadataAllowedProperties}/>);
};
